// Flame King crown logo — the full-color diamond-crown brand mark on a
// transparent background, so it reads cleanly on both the light (white) and
// dark sidebar. Built from hi-res artwork Flame King provided (background
// removed + trimmed).
//
// SELF-HOSTED: the file lives in Flame King's own GitHub repo
// (yogev-4983/flame-king-brand) and is served via the jsDelivr CDN, pinned to a
// commit SHA so the asset is immutable and long-cached — no dependency on any
// third-party marketing site. To update the logo: replace flame-king-logo.png
// in that repo and re-pin the SHA below. (If/when the dashboard's own R2 asset
// uploader is deployed for this tenant, this can move there.)
export const flamekingLogoUrl =
  "https://cdn.jsdelivr.net/gh/yogev-4983/flame-king-brand@ac6e974a8080a5e398fcb7a6e5bb71fa5fbd93b1/flame-king-logo.png";
